
module.exports = (data) => {
  const {assetCode, appBalance, walletsList, crypto_wallet_id: walletId} = data;
  const amount = `${appBalance} ${assetCode}`;
  const walletAddress = walletsList.find((el) => walletId === el.id) || {};

  return ([
    'Withdrawal request created',
    `You\'ve successfully created withdrawal request for ${amount}. Soon we'll send funds to ${walletAddress.address ? `${walletAddress.address} wallet` : ''}`
  ])
}
